/**
 * Team member invitation status DTO - represents the wire format used by the backend API.
 */
export enum TeamMemberInvitationStatusDTO {
  NOT_INVITED = 'NOT_INVITED',
  SENT = 'SENT',
  EXPIRED = 'EXPIRED',
  ACCEPTED = 'ACCEPTED',
}

/**
 * Type alias for team member invitation status in API responses.
 */
export type TeamMemberInvitationStatusResponse = TeamMemberInvitationStatusDTO;
